export default "__VITE_ASSET__BKbfUMyD__"